const english = {
  pageTitle: "Ledger Category",
  sl: "SL",
  name: "Name",
  action: "Action",
  ledgerCategory: "Ledger Category",
  addLedgerCategory: "Add Ledger Category",
  editLedgerCategory: "Edit Ledger Category",
  editLedgerCategoryForm: "Edit Ledger Category Form",
  addLedgerCategoryForm: "Add Ledger Category Form",
  warning: "Are you sure?",
  yes: "Yes Delete It!",
  youWontRevertIt: "You won't be able to revert this!",
  cancel: "Cancel",
  delete: "Delete",
  submit: "Submit",
  save: "Save",
};
const malay = {
  pageTitle: "Kategori Lejar",
  sl: "SL",
  name: "Nama",
  action: "Tindakan",
  ledgerCategory: "Kategori Lejar",
  addLedgerCategory: "Tambah Kategori Lejar",
  editLedgerCategory: "Edit Kategori Lejar",
  editLedgerCategoryForm: "Borang Edit Kategori Lejar",
  addLedgerCategoryForm: "Borang Tambah Kategori Lejar",
  warning: "Adakah anda pasti?",
  yes: "Ya, Padamkan!",
  youWontRevertIt: "Anda tidak boleh mengembalikannya!",
  cancel: "Batal",
  delete: "Padam",
  submit: "Hantar",
  save: "Simpan",
};

const thai = {
  pageTitle: "หมวดบัญชีแยกประเภท",
  sl: "ลำดับ",
  name: "ชื่อ",
  action: "การดำเนินการ",
  ledgerCategory: "หมวดบัญชีแยกประเภท",
  addLedgerCategory: "เพิ่มหมวดบัญชีแยกประเภท",
  editLedgerCategory: "แก้ไขหมวดบัญชีแยกประเภท",
  editLedgerCategoryForm: "แบบฟอร์มแก้ไขหมวดบัญชีแยกประเภท",
  addLedgerCategoryForm: "แบบฟอร์มเพิ่มหมวดบัญชีแยกประเภท",
  warning: "คุณแน่ใจหรือไม่?",
  yes: "ใช่ ลบเลย!",
  youWontRevertIt: "คุณจะไม่สามารถกู้คืนได้!",
  cancel: "ยกเลิก",
  delete: "ลบ",
  submit: "ส่ง",
  save: "บันทึก",
};

const arabic = {
  pageTitle: "فئة دفتر الأستاذ",
  sl: "الرقم التسلسلي",
  name: "الاسم",
  action: "الإجراء",
  ledgerCategory: "فئة دفتر الأستاذ",
  addLedgerCategory: "إضافة فئة دفتر الأستاذ",
  editLedgerCategory: "تعديل فئة دفتر الأستاذ",
  editLedgerCategoryForm: "نموذج تعديل فئة دفتر الأستاذ",
  addLedgerCategoryForm: "نموذج إضافة فئة دفتر الأستاذ",
  warning: "هل أنت متأكد؟",
  yes: "نعم، احذفه!",
  youWontRevertIt: "لن تتمكن من التراجع عن هذا!",
  cancel: "إلغاء",
  delete: "حذف",
  submit: "إرسال",
  save: "حفظ",
};

const bengali = {
  pageTitle: "লেজার বিভাগ",
  sl: "ক্রম",
  name: "নাম",
  action: "কর্ম",
  ledgerCategory: "লেজার বিভাগ",
  addLedgerCategory: "লেজার বিভাগ যোগ করুন",
  editLedgerCategory: "লেজার বিভাগ সম্পাদনা করুন",
  editLedgerCategoryForm: "লেজার বিভাগ সম্পাদনার ফর্ম",
  addLedgerCategoryForm: "লেজার বিভাগ যোগ করার ফর্ম",
  warning: "আপনি কি নিশ্চিত?",
  yes: "হ্যাঁ, মুছে ফেলুন!",
  youWontRevertIt: "আপনি এটি ফেরত আনতে পারবেন না!",
  cancel: "বাতিল",
  delete: "মুছে ফেলুন",
  submit: "জমা দিন",
  save: "সংরক্ষণ করুন",
};

export const ledgerCategoryLang = {
  english,
  malay,
  thai,
  arabic,
  bengali,
};
